import { assert } from '@ember/debug';
import type { Column } from 'slickgrid';
import type { ColumnFilter, DeviceData } from '../components/aditools-device-table.ts';

export default class PartialTextFilter implements ColumnFilter<DeviceData> {
  value: string;
  qaName?: string;

  constructor(initialValue?: string, qaName?: string) {
    this.value = initialValue ? initialValue : '';
    this.qaName = qaName;
  }

  populate(column: Column<DeviceData>): HTMLElement {
    if (!column) {
      throw 'column passed to populate is invalid';
    }
    const selection = $(this.generateDOMElement(column));
    selection.val(this.value);
    assert('At least one element is always generated', selection[0]);
    return selection[0];
  }

  generateDOMElement(column: Column<DeviceData>): string {
    const inputQaElement = this.qaName ? `data-qa-element="device_table_${this.qaName}_input"` : '';
    return `<input id="filter-${column.id}" type="text" autocomplete="off" class="slickgrid-filter-text" aria-label="${column.name} partial text" ${inputQaElement} data-column-id="${column.id}" />`;
  }

  update(element: HTMLInputElement): void {
    this.value = element.value;
  }

  unpack(packedValues: string): void {
    if (packedValues) {
      const initialValues = JSON.parse(packedValues);
      if (Object.prototype.hasOwnProperty.call(initialValues, 'value')) {
        this.value = initialValues.value;
      }
    }
  }

  reset(): void {
    this.value = '';
  }

  pack(): string {
    return JSON.stringify({ value: this.value });
  }

  hasValue(): boolean {
    return this.value !== '';
  }

  filter(field: string): boolean {
    const effectiveField = field ?? '';
    return effectiveField.toUpperCase().indexOf(this.value.toUpperCase()) > -1;
  }
}
